unit UZeitartModel;

interface

uses
  UEssentialHelper, Js;

type
  TZeitartModel = class
  private
    FKurzBez: string;
    FForwardAccount: Boolean;
    FBerEinheit: string;
    FBezeichnung: string;
    FId: Integer;
    FOnPropertyChanged: TCallback;
    function EncodeValue: string;
    procedure ClearValues;
    procedure PropertyChanged;
    procedure SetValues(json: string); overload;
    procedure SetValues(obj: TJsObject); overload;
    procedure SetBerEinheit(const Value: string);
    procedure SetBezeichnung(const Value: string);
    procedure SetForwardAccount(const Value: Boolean);
    procedure SetId(const Value: Integer);
    procedure SetKurzBez(const Value: string);
    procedure SetOnPropertyChanged(const Value: TCallback);
  public
    constructor Create; overload;
    constructor Create(url: string; id: Integer; callback: TCallback); overload;
    constructor Create(json: string); overload;
    function ToString: string; override;
    procedure GetById(url: string);
    property Id: Integer read FId write SetId;
    property Bezeichnung: string read FBezeichnung write SetBezeichnung;
    property KurzBez: string read FKurzBez write SetKurzBez;
    property ForwardAccount: Boolean read FForwardAccount write SetForwardAccount;
    property BerEinheit: string read FBerEinheit write SetBerEinheit;
    property OnPropertyChanged: TCallback read FOnPropertyChanged write SetOnPropertyChanged;
  end;

implementation

uses
  WebLib.JSON, System.SysUtils, WebLib.REST;

{ TZeitartModel }

procedure TZeitartModel.ClearValues;
begin
  Self.Id:=0;
  Self.Bezeichnung:='';
  Self.KurzBez:='';
  Self.ForwardAccount:=False;
  Self.BerEinheit:='';
end;

constructor TZeitartModel.Create;
begin
  Self.ClearValues;
end;

constructor TZeitartModel.Create(url: string; id: Integer; callback: TCallback);
begin
  Self.ClearValues;
  Self.OnPropertyChanged:=callback;
  Self.Id:=id;
  Self.GetById(url);
end;

function TZeitartModel.EncodeValue: string;
var obj: TJsonObject;
begin
  obj:=TJsonObject.Create;
  obj.AddPair('Id',IntToStr(Self.Id));
  Result:=obj.ToString;
  obj:=TJsonObject.Create;
  obj.AddPair('value',Result);
  Result:=obj.ToString;
  obj.Free;
end;

procedure TZeitartModel.GetById(url: string);
var client: TRestClient;
  procedure Response(Sender: TObject; AResponse: string);
  begin
    Self.SetValues(AResponse);
    Self.PropertyChanged;
  end;
begin
  client:=TRestClient.Create(nil);
  client.OnResponse:=Response;
  client.HttpsPost(url+'/ZeitartService/GetById','application/json',Self.EncodeValue);
  client.Free;
end;

procedure TZeitartModel.PropertyChanged;
begin
  if Assigned(Self.OnPropertyChanged) then
    Self.OnPropertyChanged(Self);
end;

procedure TZeitartModel.SetBerEinheit(const Value: string);
begin
  FBerEinheit := Value;
end;

procedure TZeitartModel.SetBezeichnung(const Value: string);
begin
  FBezeichnung := Value;
end;

procedure TZeitartModel.SetForwardAccount(const Value: Boolean);
begin
  FForwardAccount := Value;
end;

procedure TZeitartModel.SetId(const Value: Integer);
begin
  FId := Value;
end;

procedure TZeitartModel.SetKurzBez(const Value: string);
begin
  FKurzBez := Value;
end;

procedure TZeitartModel.SetOnPropertyChanged(const Value: TCallback);
begin
  FOnPropertyChanged := Value;
end;

procedure TZeitartModel.SetValues(obj: TJsObject);
begin
  Self.ClearValues;
  if obj['Id']<>nil then
    Self.Id:=StrToInt(string(obj['Id']));
  if obj['Bezeichnung']<>nil then
    Self.Bezeichnung:=string(obj['Bezeichnung']);
  if obj['KurzBez']<>nil then
    Self.KurzBez:=string(obj['KurzBez']);
  if obj['ForwardAccount']<>nil then
    Self.ForwardAccount:=StrToBoolean(string(obj['ForwardAccount']));
  if obj['BerEinheit']<>nil then
    Self.BerEinheit:=string(obj['BerEinheit']);
end;

function TZeitartModel.ToString: string;
begin
  Result:='Id: '+IntToStr(Self.Id);
  Result:=Result+', Bezeichnung: '+Self.Bezeichnung;
  Result:=Result+', KurzBez: '+Self.KurzBez;
  Result:=Result+', ForwardAccount: '+BooleanToStr(Self.ForwardAccount);
  Result:=Result+', BerEinheit: '+Self.BerEinheit;
end;

procedure TZeitartModel.SetValues(json: string);
var obj: TJsObject;
begin
  obj:=TJsJson.parseObject(json);
  Self.SetValues(obj);
end;

constructor TZeitartModel.Create(json: string);
begin
  Self.SetValues(json);
end;

end.
